module.exports = __webpack_public_path__ + "static/img/mobile-web-01-bg@w.199cbe4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/lotte-group/mobile-web-01-bg@w.png
// module id = e9Ac
// module chunks = 0